<template>
  <!--  解决方案 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner7.jpg')"
      :title="$t('solution.items[2].title')"
      :description="$t('solution.items[2].description')"
    />

     <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec1") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

      <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec65") }}</div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec2") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

     <div class="solution-main">
      <div class="solution-box-two">
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec66") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec70") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec67") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec71") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec68") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec72") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec69") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec73") }}</div>
        </div>
      </div>
    </div>


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec3") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

     <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec74") }}</div>

        <div class="img-box">
            <img :src=" $t('image5') " class="img-li" />
        </div>
      </div>
    </div>



    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec4") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-one">
          <img src="../assets/img/an8.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec75") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec78") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an9.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec76") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec79") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/an10.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec77") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec80") }}</p>
        </div>
      </div>
    </div>



    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec5") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

      <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-two">
          <img src="../assets/img/an20.png" class="item-one-img" />
          <div class="title-home-two">{{ $t("Solutiondec81") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec85") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an18.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec82") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec86") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an21.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec83") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec87") }}</p>
        </div>
         <div class="item-two">
          <img src="../assets/img/an19.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec84") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec88") }}</p>
        </div>
      </div>
    </div>


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec6") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    
   <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-four">
           <img src="../assets/img/jie1.jpg"  class="item-two-img" />
          <div class="title-home-two">{{ $t("Solutiondec89") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec94") }}</p>
        </div>
        <div class="item-four">
           <img src="../assets/img/jie3.jpg" class="item-two-img"  />
          <div class="title-home-two">{{ $t("Solutiondec90") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec95") }}</p>
        </div>
       <div class="item-four">
           <img src="../assets/img/jie2.jpg" class="item-two-img"  />
          <div class="title-home-two">{{ $t("Solutiondec91") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec96") }}</p>
        </div>
        <div class="item-four">
           <img src="../assets/img/jie6.jpg"  class="item-two-img"   />
          <div class="title-home-two">{{ $t("Solutiondec92") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec97") }}</p>
        </div>
         <div class="item-four">
           <img src="../assets/img/jie9.jpg"  class="item-two-img"   />
          <div class="title-home-two">{{ $t("Solutiondec93") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec98") }}</p>
        </div>
      </div>
    </div>


    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail },
  name: "NewsPage",
   mounted() {
    this.scrollToTop();
  },
  data() {
    return {
      companyName: "",
      contactPerson: "",
      contactInfo: "",
      requirements: "",
    };
  },
  methods: {
      scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleSubmit() {
      // 阻止表单的默认提交行为
      alert("提交成功"); // 提示提交成功
      // 这里可以添加进一步的逻辑，比如将表单数据发送到服务器
      console.log({
        companyName: this.companyName,
        contactPerson: this.contactPerson,
        contactInfo: this.contactInfo,
        requirements: this.requirements,
      });
    },
  },
};
</script>
<style scoped>
</style>